<template>
  <BasePopup :model-value="props.isOpen" @update:model-value="$emit('update:isOpen', $event)" custom-class="alert-popup" :show-close-button="false" :close-on-overlay="false">
    <div class="alert-content">
      <h3 v-if="data.title" class="alert-title">{{ data.title }}</h3>
      <p v-html="data.message" class="alert-message"></p>
      <div class="alert-buttons">
        <button @click="handleConfirm" class="btn btn-primary">{{ data.confirmText || '확인' }}</button>
      </div>
    </div>
    <button v-if="data.cancelButtonYn === 'Y'" @click="handleCancel" class="btn-cancel"></button>
  </BasePopup>
</template>
<script lang="ts" setup>
import BasePopup from '@/components/com/HconComBasePopup.vue'

const props = defineProps({
  isOpen: {
    type: Boolean,
    required: true
  },
  data: {
    type: Object,
    required: true,
    default: () => ({
      title: '',
      message: '',
      confirmText: '확인'
    })
  }
})

const emit = defineEmits(['cancel', 'confirm', 'update:isOpen'])

const handleConfirm = () => {
  emit('confirm')
  emit('update:isOpen', false)
}

const handleCancel = () => {
  emit('cancel')
  emit('update:isOpen', false)
}
</script>
<style lang="scss" scoped>
  
</style>